exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_weather_2zb9iOaSnP78ZeJL6Dlf6G {\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.IA_weatherIcon_rgjIEXdG0sjZ69PH4dPbf {\n  height: 65%;\n  width: fit-content;\n}\n\n.IA_weatherTemperature_1Sg4Sx5xDM16jqoMLuHA8V {\n  position: relative;\n  text-align: left;\n\n}\n\n.IA_weatherArea_3O6hEF4EASQNVaP-ErXDPa {\n  position: relative;\n  text-align: left;\n  font-weight: lighter;\n  clear: right;\n}", ""]);

// Exports
exports.locals = {
	"IA_weather": "IA_weather_2zb9iOaSnP78ZeJL6Dlf6G",
	"IA_weatherIcon": "IA_weatherIcon_rgjIEXdG0sjZ69PH4dPbf",
	"IA_weatherTemperature": "IA_weatherTemperature_1Sg4Sx5xDM16jqoMLuHA8V",
	"IA_weatherArea": "IA_weatherArea_3O6hEF4EASQNVaP-ErXDPa"
};